import { ReduxStore } from "../../reducers/root_reducer";

const getViewer = (state: ReduxStore, props) => state.viewer;

export default getViewer;
